import { setRangeMin } from './helpers';

export const setAreaMin = setRangeMin('total_area');
